/**
 * An object representing a Project
 * @typedef {Object} Project
 */

import { Model } from '@/pigeonline/wrapper';
import converter from '../components/SaveToPdf/PDFMakeConvertor.js';

export default class PigeonDocNodeModel extends Model {
  constructor(data = {}) {
    super();

    this.uuid = null;
    this.type = null;
    this.content = null;
    this.layout = null;
    this.id = null;
    this.meta = {};

    //initialize props
    this.setProps(data);

    if (this.type == 'section') {
      this.content = this.content.map((node) => new PigeonDocNodeModel(node));
    }

    if (!this.uuid) {
      this.uuid = this.createUUID();
    }
  }

  static PROJECT_TYPE() {
    return 'pigeondoc_node';
  }

  toPDFMake(options) {
    return converter[this.type](this, options);
  }

  createUUID() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    );
  }
}
